import React, { useState } from "react";
import axios from "axios";

const UploadDocument = ({ onUploadSuccess }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const allowedExtensions = [
        "pdf",
        "docx",
        "txt",
        "csv",
        "md",
    ];

    const handleFileChange = (e) => {
        setMessage("");
        setError("");

        const file = e.target.files[0];

        if (!file) {
            return;
        }

        const extension = file.name
            .split(".")
            .pop()
            .toLowerCase();

        if (!allowedExtensions.includes(extension)) {
            setError("Unsupported file type.");
            return;
        }

        setSelectedFile(file);
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setError("Please select a file.");
            return;
        }

        try {
            setUploading(true);
            setError("");
            setMessage("");

            const formData = new FormData();
            formData.append("file", selectedFile);

            const response = await axios.post(
                "http://127.0.0.1:8000/api/chatbot/upload/",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            setMessage("Document uploaded successfully.");

            setSelectedFile(null);

            if (onUploadSuccess) {
                onUploadSuccess(response.data);
            }

        } catch (err) {

            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else if (err.response?.data?.message) {
                setError(err.response.data.message);
            } else {
                setError("Upload failed.");
            }

        } finally {
            setUploading(false);
        }
    };

    return (
        <div
            style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "20px",
                marginBottom: "20px",
                background: "#ffffff",
            }}
        >
            <h3>Upload Knowledge Document</h3>

            <input
                type="file"
                onChange={handleFileChange}
            />

            <br />
            <br />

            {selectedFile && (
                <div>
                    <strong>Selected:</strong> {selectedFile.name}
                </div>
            )}

            <br />

            <button
                onClick={handleUpload}
                disabled={uploading}
                style={{
                    padding: "10px 20px",
                    cursor: "pointer",
                }}
            >
                {uploading ? "Uploading..." : "Upload"}
            </button>

            {message && (
                <p
                    style={{
                        color: "green",
                        marginTop: "15px",
                    }}
                >
                    {message}
                </p>
            )}

            {error && (
                <p
                    style={{
                        color: "red",
                        marginTop: "15px",
                    }}
                >
                    {error}
                </p>
            )}
        </div>
    );
};

export default UploadDocument;